__turbopack_context__.v({
  "iconLock": "markets-module-scss-module__ZcplWq__iconLock",
});
